module.exports = __webpack_public_path__ + "static/media/Samuel.6781eee8.svg";